var map = {
	"./brand-1.png": 60601,
	"./brand-2.png": 12418,
	"./brand-3.png": 33547,
	"./brand-4.png": 87636,
	"./brand-5.png": 8765,
	"./brand-6.png": 67526,
	"./partners-1.svg": 84133,
	"./partners-2.svg": 61702,
	"./partners-3.svg": 59735,
	"./partners-4.svg": 86904,
	"./partners-5.svg": 74793,
	"./partners-6.svg": 6682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8104;